export default (name: string, element: HTMLElement = document.body): number => {
  return parseInt(getComputedStyle(element).getPropertyValue(name), 10);
};
